export const Process = () => {
  const steps = [
    {
      title: "Requirement Analysis",
      desc: "We understand your business goals and define clear project requirements."
    },
    {
      title: "Planning & Strategy",
      desc: "We design the architecture and create a roadmap for development."
    },
    {
      title: "Development",
      desc: "Our team builds scalable and high-quality applications."
    },
    {
      title: "Testing & QA",
      desc: "We ensure bug-free performance with rigorous testing."
    },
    {
      title: "Deployment & Support",
      desc: "We launch your product and provide continuous support."
    }
  ];

  return (
    <section className="py-24 text-center">
      <h2 className="text-4xl font-bold mb-12">Our Development Process</h2>

      <div className="grid md:grid-cols-5 gap-6 max-w-6xl mx-auto">
        {steps.map((s, i) => (
          <div key={i} className="p-6 border rounded-xl">
            <h3 className="font-semibold mb-2">{s.title}</h3>
            <p className="text-sm text-gray-500">{s.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
};